// The admin-curated label a record is shown under, printed beneath the provider's own heading
// in a detail view: `preferred_title` on an event, `preferred_name` on an artist or venue.
// Renders nothing when there is none, or when it says exactly what the heading already says —
// the mirror of `ProviderLabel`, which is the same pair the other way round (in *lists* the
// curated value is the heading and the provider's is the footnote).
export const PreferredLabel = ({ label, value, original }) =>
  value && value !== original ? (
    <p className="text-sm text-muted-foreground mt-0.5">
      {label}: <span className="text-foreground font-medium">{value}</span>
    </p>
  ) : null;
